// dependancies
import React from 'react'
import PropTypes from 'prop-types'

// styles
import { ThemeProvider } from 'styled-components'
import ThemeProviderStyled from '../../theme/ThemeProvider.styled'
import * as Styled from './Notification.styled'

const Notification = ({
  colour,
  text,
  additionalText,
  ctaText,
  ctaVisuallyHiddenText,
  ctaClick,
  ctaLink,
  ctaClassName,
  ctaCustomIcon,
  ctaIconPosition = 'right',
  desktopDirection = 'row',
  withMargin = false,
}) => {
  const notificationIcon =
    colour === 'blue' ? (
      <svg aria-hidden="true" className="notification-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="14" height="14" rx="7" fill="#217BBE"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M7 3C6.44772 3 6 3.44772 6 4C6 4.55228 6.44772 5 7 5C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3ZM7 6C6.44772 6 6 6.44772 6 7V10C6 10.5523 6.44772 11 7 11C7.55228 11 8 10.5523 8 10V7C8 6.44772 7.55228 6 7 6Z" fill="white"/>
      </svg>
    ) : colour === 'yellow' ? (
      <svg aria-hidden="true" className="notification-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fillRule="evenodd" clipRule="evenodd" d="M7.98085 0.606318C7.57671 -0.202107 6.42328 -0.202106 6.01915 0.606319L0.117188 12.4126C-0.247384 13.1419 0.282827 14 1.09803 14H12.902C13.7172 14 14.2474 13.1419 13.8828 12.4126L7.98085 0.606318ZM6 5C6 4.44772 6.44772 4 7 4C7.55228 4 8 4.44772 8 5V8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8V5ZM6 11C6 10.4477 6.44772 10 7 10C7.55228 10 8 10.4477 8 11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11Z" fill="#856404"/> </svg>
    ) : colour === 'green' ? (
      <svg aria-hidden="true" className="notification-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="1" y="1" width="12" height="12" rx="6" fill="#00A76A"/> <rect x="1" y="1" width="12" height="12" rx="6" stroke="#00A76A" strokeWidth="2"/> <path d="M4.08337 7.00001L6.20459 9.33334L9.91671 4.66667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> </svg>
    ) : (
      <svg aria-hidden="true" className="notification-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="1" y="1" width="14" height="14" rx="7" fill="#D22630"/> <path d="M4.306 4.30602C4.71401 3.89799 5.37552 3.89799 5.78352 4.30602L11.6936 10.2164C12.1016 10.6244 12.1016 11.286 11.6936 11.694C11.2856 12.102 10.6241 12.102 10.2161 11.694L4.306 5.78361C3.898 5.37559 3.898 4.71405 4.306 4.30602Z" fill="white"/> <path d="M10.2165 4.30602C10.6245 3.89799 11.286 3.89799 11.694 4.30602C12.102 4.71405 12.102 5.37559 11.694 5.78361L5.78391 11.694C5.37591 12.102 4.7144 12.102 4.30639 11.694C3.89839 11.286 3.89839 10.6244 4.30639 10.2164L10.2165 4.30602Z" fill="white"/> </svg>
    )

  const ctaIcon = (
    <svg
      aria-hidden="true"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29289 0.292893C7.68342 -0.0976311 8.31658 -0.0976311 8.70711 0.292893L13.7071 5.29289C14.0976 5.68342 14.0976 6.31658 13.7071 6.70711L8.70711 11.7071C8.31658 12.0976 7.68342 12.0976 7.29289 11.7071C6.90237 11.3166 6.90237 10.6834 7.29289 10.2929L10.5858 7H1C0.447715 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5H10.5858L7.29289 1.70711C6.90237 1.31658 6.90237 0.683417 7.29289 0.292893Z"
        fill="#1B1E1C"
      />
    </svg>
  )

  return (
    <ThemeProvider theme={ThemeProviderStyled}>
      <Styled.NotificationStyled
        notificationType={colour}
        role={colour !== 'blue' ? 'alert' : undefined}
        margin={withMargin}
      >
        {notificationIcon}
        <Styled.NotificationContent desktopDirection={desktopDirection}>
          <Styled.NotificationTextWrapper>
            <p>{text}</p>
            {additionalText && (
              <p>
                {additionalText}

                {(colour === 'blue') && (
                  <>
                    &nbsp;
                    
                    <a
                      href={ctaLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${ctaClassName ? ctaClassName : 'gtm-banner'}`}
                    >
                      {ctaText}
                      
                      {ctaVisuallyHiddenText && (
                        <>
                          <span className='visually-hidden'>{ctaVisuallyHiddenText}</span>
                        </>
                      )}
                    </a>
                  </>
                )}
              </p>
            )}
          </Styled.NotificationTextWrapper>
          {ctaText &&
            (ctaLink ? (
              <>
                {(colour !== 'blue') && (
                  <a
                    href={ctaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${ctaClassName ? ctaClassName : 'gtm-banner'} notification-cta`}
                  >
                    {ctaText}
                    {ctaVisuallyHiddenText && (
                      <>
                        <span className='visually-hidden'>{ctaVisuallyHiddenText}</span>
                      </>
                    )}
                    {ctaIcon}  
                  </a>
                )}
              </>
            ) : (
              <button onClick={ctaClick} type="button" className="notification-cta gtm-banner">
                {ctaIconPosition === 'left' && (ctaCustomIcon || ctaIcon)}
                {ctaText}
                {ctaVisuallyHiddenText && (
                  <>
                    <span className='visually-hidden'>{ctaVisuallyHiddenText}</span>
                  </>
                )}
                {ctaIconPosition === 'right' && (ctaCustomIcon || ctaIcon)}
              </button>
            ))}
        </Styled.NotificationContent>
      </Styled.NotificationStyled>
    </ThemeProvider>
  )
}

export default Notification

Notification.propTypes = {
  colour: PropTypes.oneOf(['blue', 'yellow', 'red', 'green']).isRequired,
  text: PropTypes.string.isRequired,
  additionalText: PropTypes.string,
  ctaText: PropTypes.string,
  ctaClick: PropTypes.func,
  ctaLink: PropTypes.string,
  className: PropTypes.string,
  desktopDirection: PropTypes.string,
}
